<template>
	<div class="all-wrap">
		<!-- 微信分享卡片(标题/描述/首图 = 客户 logo) -->
		<ShareMeta :title="shareTitle" :description="shareDesc" :image="brandLogo" />

		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>
		<!-- 左侧悬浮板块导航 -->
		<SectionNav :active="activeTab" />

		<!-- 顶部 banner 区(站内风格:暗色大图 + 顶部导航) -->
		<div class="videolist-banner">
			<!-- 顶部导航栏 -->
			<Headernew />

			<div class="wow fadeInUp bannertop-title">
				<div>项目方案 · 详情分享</div>
				<div>——后天科技·管理方案、报价、作品与案例</div>
			</div>
		</div>

		<!-- ===================== 页主体：该客户的方案 ===================== -->
		<div class="app-container" ref="contentArea">
			<div class="brand-head">
				<h1 class="brand-title">
					<i class="iconfont icon-shoushimima"></i> {{ brandName || '项目方案' }}
				</h1>
				<div class="brand-head-actions">
					<button v-if="isVip" class="tag-manage-btn" @click="openTagDialog">
						<font-awesome-icon icon="fa-solid fa-tags" /> 管理标签
					</button>
					<button class="brand-back" @click="backToBrands">
						<font-awesome-icon icon="fa-solid fa-arrow-left" /> 返回客户列表
					</button>
				</div>
			</div>

			<!-- ============ 方案面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'scheme'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="schemeName" placeholder="请输入名称" @keyup.enter="loadScheme" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<select class="search-input" v-model="schemeTags" @change="loadScheme">
								<option value="">全部</option>
								<option v-for="tag in enabledTags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
							</select>
						</span>
						<button class="search-btn" @click="loadScheme"><i class="iconfont icon-search"></i> 搜索</button>
						<button v-if="isVip" class="add-work-btn" @click="openCreateWork"><font-awesome-icon icon="fa-solid fa-plus" /> 新增</button>
					</div>
				</div>

				<LoadingBlock v-if="loading.scheme" />

				<div class="timeline" v-else>
					<div class="empty-state" v-if="groupedScheme.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ listError.scheme || '暂无方案' }}</p>
					</div>

					<div class="tl-group" v-for="group in groupedScheme" :key="group.date">
						<div class="tl-group-head">
							<div class="tl-marker tl-marker-date"></div>
							<div class="tl-date">{{ group.date }}</div>
						</div>
						<div class="timeline-item" v-for="item in group.items" :key="item.id" @click="toSchemeDetail(item.id)">
							<div class="tl-marker"></div>
							<div class="tl-body">
								<div class="tl-card">
									<div class="tl-title">{{ item.main }}</div>
									<div class="tl-tags">
										<span v-if="item.keys_name">{{ item.keys_name }}</span>
									</div>
									<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
									<div v-if="isVip" class="tl-toggle" :class="{ 'is-hidden': item.on_show === 0 }" @click.stop="toggleShow(item)" :title="item.on_show === 0 ? '设为可见' : '设为隐藏'">
										<font-awesome-icon :icon="item.on_show === 0 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-del" @click.stop="removeItem(item)" title="删除">
										<font-awesome-icon icon="fa-solid fa-trash-can" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-edit" @click.stop="openEditWork(item)" title="编辑">
										<font-awesome-icon icon="fa-solid fa-pen-to-square" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 报价面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'budget'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="budgetName" placeholder="请输入名称" @keyup.enter="loadBudget" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<select class="search-input" v-model="budgetTags" @change="loadBudget">
								<option value="">全部</option>
								<option v-for="tag in enabledTags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
							</select>
						</span>
						<button class="search-btn" @click="loadBudget"><i class="iconfont icon-search"></i> 搜索</button>
						<button v-if="isVip" class="add-work-btn" @click="openCreateWork"><font-awesome-icon icon="fa-solid fa-plus" /> 新增</button>
					</div>
				</div>

				<LoadingBlock v-if="loading.budget" />

				<div class="timeline" v-else>
					<div class="empty-state" v-if="groupedBudget.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ listError.budget || '暂无报价' }}</p>
					</div>

					<div class="tl-group" v-for="group in groupedBudget" :key="group.date">
						<div class="tl-group-head">
							<div class="tl-marker tl-marker-date"></div>
							<div class="tl-date">{{ group.date }}</div>
						</div>
						<div class="timeline-item" v-for="item in group.items" :key="item.id" @click="toBudgetDetail(item.id)">
							<div class="tl-marker"></div>
							<div class="tl-body">
								<div class="tl-card">
									<div class="tl-title">{{ item.main }}</div>
									<div class="tl-tags">
										<span v-if="item.keys_name">{{ item.keys_name }}</span>
									</div>
									<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
									<div v-if="isVip" class="tl-toggle" :class="{ 'is-hidden': item.on_show === 0 }" @click.stop="toggleShow(item)" :title="item.on_show === 0 ? '设为可见' : '设为隐藏'">
										<font-awesome-icon :icon="item.on_show === 0 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-del" @click.stop="removeItem(item)" title="删除">
										<font-awesome-icon icon="fa-solid fa-trash-can" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-edit" @click.stop="openEditWork(item)" title="编辑">
										<font-awesome-icon icon="fa-solid fa-pen-to-square" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 作品面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'works'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="workName" placeholder="请输入名称" @keyup.enter="loadWorks" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<select class="search-input" v-model="workTags" @change="loadWorks">
								<option value="">全部</option>
								<option v-for="tag in enabledTags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
							</select>
						</span>
						<button class="search-btn" @click="loadWorks"><i class="iconfont icon-search"></i> 搜索</button>
						<button v-if="isVip" class="add-work-btn" @click="openCreateWork"><font-awesome-icon icon="fa-solid fa-plus" /> 新增</button>
					</div>
				</div>

				<LoadingBlock v-if="loading.works" />

				<div class="timeline" v-else>
					<div class="empty-state" v-if="groupedWorks.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ listError.works || '暂无作品' }}</p>
					</div>

					<div class="tl-group" v-for="group in groupedWorks" :key="group.date">
						<div class="tl-group-head">
							<div class="tl-marker tl-marker-date"></div>
							<div class="tl-date">{{ group.date }}</div>
						</div>
						<div class="timeline-item" v-for="item in group.items" :key="item.id" @click="toWorkDetail(item.id)">
							<div class="tl-marker"></div>
							<div class="tl-body">
								<div class="tl-card">
									<div class="tl-title">{{ item.main }}</div>
									<div class="tl-tags">
										<span v-if="item.keys_name">{{ item.keys_name }}</span>
									</div>
									<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
									<div v-if="isVip" class="tl-toggle" :class="{ 'is-hidden': item.on_show === 0 }" @click.stop="toggleShow(item)" :title="item.on_show === 0 ? '设为可见' : '设为隐藏'">
										<font-awesome-icon :icon="item.on_show === 0 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-del" @click.stop="removeItem(item)" title="删除">
										<font-awesome-icon icon="fa-solid fa-trash-can" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-edit" @click.stop="openEditWork(item)" title="编辑">
										<font-awesome-icon icon="fa-solid fa-pen-to-square" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- ============ 案例面板 ============ -->
			<div class="tab-panel" v-show="activeTab === 'cases'">
				<div class="panel-toolbar">
					<div class="search-wrap">
						<span class="search-field">
							<label class="search-label">名称</label>
							<input class="search-input" type="text" v-model="caseName" placeholder="请输入名称" @keyup.enter="loadCases" />
						</span>
						<span class="search-field">
							<label class="search-label">标签</label>
							<select class="search-input" v-model="caseTags" @change="loadCases">
								<option value="">全部</option>
								<option v-for="tag in enabledTags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
							</select>
						</span>
						<button class="search-btn" @click="loadCases"><i class="iconfont icon-search"></i> 搜索</button>
						<button v-if="isVip" class="add-work-btn" @click="openCreateWork"><font-awesome-icon icon="fa-solid fa-plus" /> 新增</button>
					</div>
				</div>

				<LoadingBlock v-if="loading.cases" />

				<div class="timeline" v-else>
					<div class="empty-state" v-if="groupedCases.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ listError.cases || '暂无案例' }}</p>
					</div>

					<div class="tl-group" v-for="group in groupedCases" :key="group.date">
						<div class="tl-group-head">
							<div class="tl-marker tl-marker-date"></div>
							<div class="tl-date">{{ group.date }}</div>
						</div>
						<div class="timeline-item" v-for="item in group.items" :key="item.id" @click="toCaseDetail(item.id)">
							<div class="tl-marker"></div>
							<div class="tl-body">
								<div class="tl-card">
									<div class="tl-title">{{ item.main }}</div>
									<div class="tl-tags">
										<span v-if="item.keys_name">{{ item.keys_name }}</span>
									</div>
									<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
									<div v-if="isVip" class="tl-toggle" :class="{ 'is-hidden': item.on_show === 0 }" @click.stop="toggleShow(item)" :title="item.on_show === 0 ? '设为可见' : '设为隐藏'">
										<font-awesome-icon :icon="item.on_show === 0 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-del" @click.stop="removeItem(item)" title="删除">
										<font-awesome-icon icon="fa-solid fa-trash-can" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-edit" @click.stop="openEditWork(item)" title="编辑">
										<font-awesome-icon icon="fa-solid fa-pen-to-square" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<!-- 方案/案例 新增·编辑弹窗 -->
		<el-dialog :title="workForm.id ? '编辑' : '新增'"
			:visible.sync="workDialogVisible" width="820px" :close-on-click-modal="false" append-to-body>
			<el-form label-width="92px" size="small" class="work-form">
				<el-form-item label="名称" required>
					<el-input v-model="workForm.main" placeholder="请输入名称" maxlength="80" />
				</el-form-item>
				<el-form-item label="标签">
					<el-select v-model="workForm.code_id" placeholder="请选择标签" style="width:100%">
						<!-- value 用字符串：接口返回的 tags 是字符串，严格相等才能匹配上并显示名称 -->
						<el-option v-for="t in enabledTags" :key="t.id" :label="t.name" :value="String(t.id)" />
					</el-select>
				</el-form-item>
				<el-form-item label="方案HTML">
					<FileUploader v-model="workForm.html_url" accept=".html,text/html" type="html" />
				</el-form-item>
				<el-form-item label="报价PDF">
					<FileUploader v-model="workForm.pdf" accept="application/pdf" type="pdf" />
				</el-form-item>
				<el-form-item label="作品视频">
					<FileUploader v-model="workForm.open" accept="video/*" type="video" />
				</el-form-item>
				<el-form-item label="作品图片">
					<FileUploader v-model="workForm.simg" accept="image/*" type="image" />
				</el-form-item>
				<el-form-item label="作品外链">
					<el-input v-model="workForm.link_url" placeholder="http://..." />
				</el-form-item>
				<el-form-item label="作品描述">
					<el-input v-model="workForm.detail" type="textarea" :rows="3" placeholder="请输入作品描述" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="workDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="workSaving" @click="submitWork">保存</el-button>
			</span>
		</el-dialog>

		<!-- 标签管理弹窗 -->
		<el-dialog title="标签管理" :visible.sync="tagDialogVisible" width="520px" append-to-body>
			<div class="tag-add">
				<el-input v-model="newTagName" placeholder="输入新标签名称" size="small" @keyup.enter.native="saveTag()" />
				<el-button type="primary" size="small" :loading="tagSaving === 'new'" @click="saveTag()">新增</el-button>
			</div>
			<div class="tag-manage-list">
				<div class="tag-manage-row" v-for="t in tagList" :key="t.id">
					<el-input v-model="t.name" size="mini" class="tag-name-input" />
					<el-button size="mini" :loading="tagSaving === t.id" @click="saveTag(t)">保存</el-button>
					<el-button size="mini" :type="t.on_show === 1 ? 'success' : 'info'" @click="toggleTag(t)">
						{{ t.on_show === 1 ? '显示中' : '已隐藏' }}
					</el-button>
				</div>
				<div class="tag-manage-empty" v-if="tagList.length === 0">暂无标签</div>
			</div>
		</el-dialog>

		<!-- 底部页脚(项目统一) -->
		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'
import SectionNav from '@/components/SectionNav.vue'
import FileUploader from '@/components/FileUploader.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import ShareMeta from '@/components/ShareMeta.vue'

export default {
	name: 'brandProposal',
	components: { Headernew, Footernew, Comment, gotop, SectionNav, FileUploader, LoadingBlock, ShareMeta },
	data() {
		return {
			activeTab: 'scheme',
			// 当前客户
			brandId: this.$route.query.brand_id || '',
			brandName: '',
			brandLogo: '',            // 客户 logo(分享缩略图)

			// 列表数据(后端接口)
			schemeList: [],
			budgetList: [],
			worksList: [],
			casesList: [],

			// 各列表的加载态与错误提示
			loading: { scheme: false, budget: false, works: false, cases: false },
			listError: { scheme: '', budget: '', works: '', cases: '' },

			// 标签下拉选项(来自 getKeys)
			tagList: [],

			// 搜索关键词
			schemeName: '',
			schemeTags: '',
			budgetName: '',
			budgetTags: '',
			workName: '',
			workTags: '',
			caseName: '',
			caseTags: '',

			// 从 URL 进入时是否需要定位到内容区
			needScrollContent: false,

			// 方案/案例 新增·编辑表单
			workDialogVisible: false,
			workSaving: false,
			workForm: {
				id: null,
				main: '',
				code_id: '',
				simg: '',
				link_url: '',
				pdf: '',
				style: 'work',
				open: '',
				html_url: '',
				detail: '',
			},

			// 标签管理
			tagDialogVisible: false,
			newTagName: '',
			tagSaving: '',            // 正在保存的标签('new' 表示新增那行)
		}
	},
	computed: {
		// 各列表按天分组(同一天的方案归到一个日期下,日期只显示一次)
		groupedScheme() { return this.groupByDate(this.schemeList) },
		groupedBudget() { return this.groupByDate(this.budgetList) },
		groupedWorks() { return this.groupByDate(this.worksList) },
		groupedCases() { return this.groupByDate(this.casesList) },
		// 启用的标签(下拉筛选项)
		enabledTags() { return this.tagList.filter(t => t.on_show === 1) },
		// 微信分享标题/描述
		shareTitle() { return this.brandName ? this.brandName + ' · 项目方案' : '后天科技 · 项目方案' },
		shareDesc() { return this.brandName ? this.brandName + '的方案、报价、作品与案例，点击查看' : '选择客户，查看方案、报价、作品与案例' },
		// 是否 VIP：与 Headernew 一致，取缓存 usermessage.adminid == 1
		// 新增/编辑/删除/切换可见性/标签管理 等管理操作仅 VIP 可见可操作
		isVip() {
			try {
				const m = localStorage.getItem('usermessage')
				if (!m) return false
				return JSON.parse(m).adminid == 1
			} catch (e) {
				return false
			}
		},
	},
	watch: {
		// 详情页面包屑跳回本页(路径同为 /projectProposal,可能仅 query 变化)时重新定位 tab
		'$route'() { this.applyRouteQuery(this.$route.query) },
	},
	created() {
		this.applyRouteQuery(this.$route.query)
	},
	mounted() {
		this.loadBrand()
		this.loadTags()
		this.loadScheme()
		this.loadBudget()
		this.loadWorks()
		this.loadCases()
		// 详情面包屑返回后，滚动到 Tab 内容区
		if (this.needScrollContent) {
			this.$nextTick(() => {
				const el = this.$refs.contentArea
				if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
			})
		}
	},
	methods: {
		// 根据 URL query 切换 Tab(四个 tab 都接受；缺省/非法时默认 scheme)
		applyRouteQuery(q) {
			q = q || {}
			const tabs = ['scheme', 'budget', 'works', 'cases']
			this.activeTab = tabs.indexOf(q.tab) !== -1 ? q.tab : 'scheme'
			this.needScrollContent = true
		},

		// 时间轴排序:按 created_at 倒序
		// 排序(时间倒序)后按天分组：返回 [{ date, items:[...] }]
		groupByDate(list) {
			if (!Array.isArray(list)) return []
			const t = (v) => new Date(String(v || '').replace(' ', 'T')).getTime() || 0
			const sorted = [...list].sort((a, b) => t(b.created_at) - t(a.created_at))
			const groups = []
			const map = {}
			sorted.forEach((item) => {
				const date = this.fmtDate(item.created_at)
				if (!map[date]) {
					map[date] = { date, items: [] }
					groups.push(map[date])
				}
				map[date].items.push(item)
			})
			return groups
		},
		// 日期只取年月日
		fmtDate(v) {
			if (!v) return ''
			return String(v).slice(0, 10)
		},

		// 通用列表请求：统一处理 loading / 错误提示 / 空列表
		// key: scheme|budget|works|cases ；pick: 可选过滤(按字段判断归属板块)
		fetchList(key, style, params, pick) {
			this.loading[key] = true
			this.listError[key] = ''
			return this.$axios.get(this.$api + '/getWorksCase', {
				params: Object.assign({ style, brand_id: this.brandId, page: 1, limit: 1000 }, params)
			}).then(res => {
				const body = res.data || {}
				const list = (body.result && body.result.data) || []
				this[key + 'List'] = pick ? list.filter(pick) : list
				// 接口返回 success:false 且无数据时，把 message 作为提示
				if (!body.success && !list.length) this.listError[key] = body.message || ''
			}).catch(err => {
				console.log(err)
				this[key + 'List'] = []
				this.listError[key] = '加载失败，请稍后重试'
			}).finally(() => { this.loading[key] = false })
		},
		// ---- 方案列表(style=work，html_url 作为方案) ----
		loadScheme() {
			return this.fetchList('scheme', 'work', {
				name: this.schemeName || undefined, tags: this.schemeTags || undefined
			}, i => i.html_url)
		},
		// ---- 报价列表(style=work，pdf_url 作为报价) ----
		loadBudget() {
			return this.fetchList('budget', 'work', {
				name: this.budgetName || undefined, tags: this.budgetTags || undefined
			}, i => i.pdf_url)
		},
		// ---- 作品列表(style=work，video_url/image_url/link_url 作为作品) ----
		loadWorks() {
			return this.fetchList('works', 'work', {
				name: this.workName || undefined, tags: this.workTags || undefined
			}, i => i.video_url || i.image_url || i.link_url)
		},
		// ---- 案例列表(只看当前客户) ----
		loadCases() {
			return this.fetchList('cases', 'case', {
				name: this.caseName || undefined, tags: this.caseTags || undefined
			})
		},
		// 拉取当前客户名(用于标题)——接口分页，传 page/limit 一次拉全再匹配
		loadBrand() {
			this.$axios.get(this.$api + '/getBrand', {
				params: { page: 1, limit: 1000 }
			}).then(res => {
				const list = (res.data.result && res.data.result.data) || []
				const cur = list.find(b => String(b.id) === String(this.brandId))
				if (cur) {
					this.brandName = cur.name
					this.brandLogo = cur.logo_url || ''
				}
			}).catch(err => console.log(err))
		},
		// 拉取标签(全量含停用——用于把列表项的标签 ID 映射成名称；下拉筛选项只取启用的)
		loadTags() {
			this.$axios.get(this.$api + '/getKeys', {
				params: { on_show: 0, page: 1, limit: 1000 }
			}).then(res => {
				this.tagList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// 切换可见性(worksShow 无参自动翻转)，二次确认后刷新当前面板
		toggleShow(item) {
			// 当前非隐藏态即视为可见，点击后将被隐藏
			const willHide = item.on_show !== 0
			const tip = willHide
				? '确定将「' + (item.main || '该记录') + '」设为隐藏吗？隐藏后客户端将看不到。'
				: '确定将「' + (item.main || '该记录') + '」设为可见吗？'
			this.$confirm(tip, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				return this.$axios.post(this.$api + '/worksShow/' + item.id)
			}).then(() => {
				this.$message && this.$message.success('可见性已更新')
				this.reloadActivePanel()
			}).catch(err => {
				// 取消确认弹窗时 err 为 'cancel'/'close'，不提示错误
				if (err === 'cancel' || err === 'close') return
				console.log(err)
				this.$message && this.$message.error('操作失败')
			})
		},
		// 删除记录(deleteWorkcase/{id})，二次确认后刷新当前面板
		removeItem(item) {
			this.$confirm('确定删除「' + (item.main || '该记录') + '」吗？删除后不可恢复。', '删除确认', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning',
				confirmButtonClass: 'el-button--danger', // 确认按钮用危险色
			}).then(() => {
				return this.$axios.post(this.$api + '/deleteWorkcase/' + item.id)
			}).then(() => {
				this.$message && this.$message.success('已删除')
				this.reloadActivePanel()
			}).catch(err => {
				// 取消确认弹窗时 err 为 'cancel'/'close'，不提示错误
				if (err === 'cancel' || err === 'close') return
				console.log(err)
				this.$message && this.$message.error('删除失败')
			})
		},
		// 刷新当前 Tab 对应的列表
		reloadActivePanel() {
			if (this.activeTab === 'scheme') this.loadScheme()
			else if (this.activeTab === 'budget') this.loadBudget()
			else if (this.activeTab === 'works') this.loadWorks()
			else this.loadCases()
		},

		// ============ 方案/案例 新增·编辑 ============
		// 新增：类型由当前面板决定(案例面板=case，其余=work)
		openCreateWork() {
			this.workForm = {
				id: null, main: '', code_id: '', simg: '', link_url: '', pdf: '',
				style: this.activeTab === 'cases' ? 'case' : 'work',
				open: '', html_url: '', detail: '',
			}
			this.workDialogVisible = true
		},
		// 编辑：回填现有记录(接口字段 → 表单字段)
		openEditWork(item) {
			this.workForm = {
				id: item.id,
				main: item.main || '',
				code_id: item.tags || '',
				simg: item.image_url || '',
				link_url: item.link_url || '',
				pdf: item.pdf_url || '',
				style: item.type === 'case' ? 'case' : 'work',
				open: item.video_url || '',
				html_url: item.html_url || '',
				detail: item.content || '',
			}
			this.workDialogVisible = true
		},
		// 保存(saveWorkcases)：带 id 改、不带 id 增(仅名称必填)
		submitWork() {
			const f = this.workForm
			if (!String(f.main || '').trim()) {
				this.$message && this.$message.warning('请输入名称')
				return
			}
			this.workSaving = true
			const payload = {
				main: f.main,
				code_id: String(f.code_id),
				simg: f.simg,
				link_url: f.link_url,
				pdf: f.pdf,
				style: f.style,
				open: f.open,
				brand_id: String(this.brandId),
				html_url: f.html_url,
				detail: f.detail,
			}
			if (f.id) payload.id = f.id
			this.$axios.post(this.$api + '/saveWorkcases', payload).then(res => {
				const body = res.data || {}
				if (body.success || body.result) {
					this.workDialogVisible = false
					this.$message && this.$message.success(f.id ? '已保存' : '已新增')
					this.reloadActivePanel()
				} else {
					this.$message && this.$message.error(body.message || '保存失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message && this.$message.error('保存失败')
			}).finally(() => { this.workSaving = false })
		},

		// ============ 标签管理 ============
		openTagDialog() {
			this.newTagName = ''
			this.tagDialogVisible = true
		},
		// 新增或修改标签(saveKey)：带 id 改、不带 id 增
		saveTag(tag) {
			const name = (tag ? tag.name : this.newTagName || '').trim()
			if (!name) {
				this.$message && this.$message.warning('请输入标签名称')
				return
			}
			const payload = { name }
			if (tag) payload.id = tag.id
			this.tagSaving = tag ? tag.id : 'new'
			this.$axios.post(this.$api + '/saveKey', payload).then(res => {
				const body = res.data || {}
				if (body.success || body.result) {
					this.$message && this.$message.success(tag ? '已修改' : '已新增')
					if (!tag) this.newTagName = ''
					this.loadTags()
				} else {
					this.$message && this.$message.error(body.message || '保存失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message && this.$message.error('保存失败')
			}).finally(() => { this.tagSaving = '' })
		},
		// 切换标签是否可见(keyShow/{id})
		toggleTag(tag) {
			this.$axios.post(this.$api + '/keyShow/' + tag.id).then(() => {
				this.$message && this.$message.success('标签可见性已更新')
				this.loadTags()
			}).catch(err => {
				console.log(err)
				this.$message && this.$message.error('操作失败')
			})
		},
		// 返回客户列表(带上当前板块，回到列表页对应 Tab)
		backToBrands() {
			this.$router.push({ path: '/projectProposal', query: { tab: this.activeTab } })
		},

		// ---- 跳转详情 ----
		// 进详情页带上 brand_id，详情页"返回"才能回到该客户
		toSchemeDetail(id) { this.$router.push({ path: '/schemeDetail', query: { id, brand_id: this.brandId } }) },
		toBudgetDetail(id) { this.$router.push({ path: '/budgetDetail', query: { id, brand_id: this.brandId } }) },
		toWorkDetail(id) { this.$router.push({ path: '/workDetail', query: { id, brand_id: this.brandId } }) },
		toCaseDetail(id) { this.$router.push({ path: '/proposalCaseDetail', query: { id, brand_id: this.brandId } }) },
	},
}
</script>

<style scoped>
/* 统一盒模型，避免 width:100% + padding 导致手机端右侧溢出贴边 */
.all-wrap,
.all-wrap * {
	box-sizing: border-box;
}

/* 顶部 banner 区(站内风格) */
.videolist-banner {
	width: 100%;
	height: 700px;
	background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg);
	background-size: 100% 100%;
	position: relative;
}
.bannertop-title { width: 100%; position: absolute; left: 0; top: 30%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 61px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 35px auto 0; font-size: 31px; color: #fff; text-align: right; letter-spacing: 2px; }

/* 主体内容区 */
.app-container { max-width: 1280px; margin: 0 auto; padding: 2rem 1.5rem 4rem; }

/* 标题行：客户名(左) + 返回按钮(右) */
.brand-head { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin-bottom: 2rem; }
.brand-title { font-size: 1.75rem; font-weight: 600; color: #0a2540; display: flex; align-items: center; gap: .75rem; margin: 0; }
.brand-title i { color: #2563eb; }

/* 返回客户列表：胶囊按钮，左箭头，悬停填充蓝色并左移 */
.brand-back {
	display: inline-flex;
	align-items: center;
	gap: .4rem;
	background: #fff;
	color: #2563eb;
	border: 1.5px solid #dbeafe;
	padding: .55rem 1.15rem;
	border-radius: 999px;
	font-size: .9rem;
	font-weight: 600;
	cursor: pointer;
	box-shadow: 0 2px 6px rgba(37,99,235,.08);
	transition: all .2s ease;
}
.brand-back svg { width: 13px; height: 13px; transition: transform .2s; }
.brand-back:hover {
	background: #2563eb;
	color: #fff;
	border-color: #2563eb;
	box-shadow: 0 8px 18px rgba(37,99,235,.28);
	transform: translateX(-3px);
}
.brand-back:hover svg { transform: translateX(-2px); }
/* 标题行右侧按钮组 */
.brand-head-actions { display: inline-flex; align-items: center; gap: .6rem; flex-wrap: wrap; }
.tag-manage-btn {
	display: inline-flex; align-items: center; gap: .4rem;
	background: #fff; color: #475569; border: 1.5px solid #e2e8f0;
	padding: .55rem 1.15rem; border-radius: 999px;
	font-size: .9rem; font-weight: 600; cursor: pointer;
	transition: all .2s ease;
}
.tag-manage-btn:hover { color: #2563eb; border-color: #93c5fd; background: #f0f6ff; }
.tag-manage-btn svg { width: 13px; height: 13px; }

/* 面板内的"新增"按钮 */
.add-work-btn {
	background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff; border: none;
	padding: .5rem 1.1rem; border-radius: 8px; font-weight: 600; font-size: .9rem;
	cursor: pointer; display: inline-flex; align-items: center; justify-content: center; gap: .35rem;
	box-shadow: 0 4px 12px rgba(37,99,235,.28); transition: all .2s ease;
}
.add-work-btn:hover { transform: translateY(-1px); box-shadow: 0 7px 16px rgba(37,99,235,.4); }
.add-work-btn svg { width: 12px; height: 12px; }

/* 标签管理弹窗 */
.tag-add { display: flex; gap: .6rem; margin-bottom: 1rem; }
.tag-manage-list { max-height: 340px; overflow: auto; }
.tag-manage-row { display: flex; align-items: center; gap: .5rem; margin-bottom: .55rem; }
.tag-name-input { flex: 1; }
.tag-manage-empty { text-align: center; color: #94a3b8; padding: 1.5rem 0; font-size: .9rem; }
/* 表单弹窗：上传控件占满一行 */
.work-form .el-form-item { margin-bottom: 14px; }

.tab-panel { background: #fff; border-radius: 16px; padding: 1.5rem 1.5rem 2rem; box-shadow: 0 4px 12px rgba(0,0,0,.03); min-height: 420px; }

/* 工具栏 + 搜索 */
.panel-toolbar { margin-bottom: 1.25rem; }
.search-wrap { display: flex; gap: .75rem; flex-wrap: wrap; align-items: center; }
.search-field { display: flex; align-items: center; gap: .4rem; flex: 1; min-width: 180px; }
.search-label { flex-shrink: 0; font-size: .9rem; font-weight: 600; color: #475569; }
.search-input { flex: 1; min-width: 0; width: 100%; padding: .5rem .75rem; border: 1px solid #e2e8f0; border-radius: 8px; font-size: .9rem; outline: none; }
.search-input:focus { border-color: #2563eb; }
/* 下拉选择：去掉默认箭头，自定义与输入框风格一致的箭头 */
select.search-input {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	background-color: #fff;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right .6rem center;
	padding-right: 1.8rem;
	cursor: pointer;
}
.search-btn { background: #2563eb; color: #fff; border: none; padding: .5rem 1.2rem; border-radius: 8px; font-weight: 500; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; transition: background .2s; }
.search-btn:hover { background: #1d4ed8; }


/* ==================== 时间轴 ==================== */
.timeline { margin-top: .75rem; position: relative; }
/* 连续竖线：贯穿整条时间轴，圆点落在线上 */
.timeline::before {
	content: '';
	position: absolute;
	left: 14px;                /* marker 列(30px)的中心 */
	top: 10px;
	bottom: 10px;
	width: 2px;
	background: linear-gradient(to bottom, #bfdbfe, #cbd5e1);
	border-radius: 2px;
}
.timeline-item { position: relative; display: flex; cursor: pointer; }

/* marker 列：圆点 */
.tl-marker {
	position: relative;
	width: 30px;               /* marker 列固定宽度 */
	flex: 0 0 30px;
	display: flex;
	justify-content: center;
}
/* 圆点：渐变实心 + 白环 + 蓝色光晕，盖在竖线之上 */
.timeline-item .tl-marker::after {
	content: '';
	position: absolute;
	top: 10px;
	left: 50%;
	transform: translateX(-50%);
	width: 13px;
	height: 13px;
	background: linear-gradient(135deg, #60a5fa, #2563eb);
	border-radius: 9999px;
	border: 2px solid #fff;
	box-shadow: 0 0 0 4px rgba(37,99,235,.12), 0 2px 6px rgba(37,99,235,.35);
	z-index: 1;
	transition: box-shadow .25s ease;
}
/* 悬停整行：圆点光晕加强 */
.timeline-item:hover .tl-marker::after {
	box-shadow: 0 0 0 6px rgba(37,99,235,.18), 0 2px 8px rgba(37,99,235,.45);
}

/* 日期分组头 */
.tl-group { margin-bottom: .5rem; }
.tl-group-head { display: flex; align-items: center; margin-bottom: .5rem; }
.tl-group-head .tl-marker-date { height: 24px; }
/* 日期做成胶囊徽章 */
.tl-group-head .tl-date {
	display: inline-flex;
	align-items: center;
	margin: 0 0 0 .2rem;
	background: linear-gradient(135deg, #eff6ff, #dbeafe);
	color: #1d4ed8;
	font-size: .78rem;
	font-weight: 700;
	padding: .28rem .85rem;
	border-radius: 999px;
	letter-spacing: .4px;
	box-shadow: 0 1px 4px rgba(37,99,235,.15);
}

/* 内容列 */
.timeline-item .tl-body { flex: 1; min-width: 0; padding-bottom: 1.5rem; }
.tl-card {
	position: relative;          /* 可见性开关的定位锚点 */
	padding: 1rem 1.25rem;
	background: #fff;
	border-radius: 12px;
	border: 1px solid #eef2f6;
	border-left: 3px solid #2563eb;
	box-shadow: 0 1px 3px rgba(15,23,42,.05);
	transition: all .2s ease;
	text-align: left;
}
/* 可见性开关：悬浮卡片时右上角出现小眼睛 */
.tl-toggle {
	position: absolute; top: 8px; right: 8px;
	width: 26px; height: 26px; border-radius: 8px;
	display: flex; align-items: center; justify-content: center;
	background: rgba(15,23,42,.06); color: #64748b; cursor: pointer;
	opacity: 0; transition: all .2s ease;
}
.tl-toggle:hover { background: #2563eb; color: #fff; }
.tl-toggle svg { width: 13px; height: 13px; }
.tl-card:hover .tl-toggle { opacity: 1; }
/* 隐藏态的开关常显并带琥珀色提示 */
.tl-toggle.is-hidden { opacity: 1; color: #d97706; background: rgba(245,158,11,.12); }
/* 删除按钮：排在眼睛左侧，悬浮变红 */
.tl-del { right: 40px; }
.tl-del:hover { background: #dc2626; color: #fff; }
/* 编辑按钮：排在删除左侧(必须写在 .tl-toggle 之后，否则被其 right:8px 覆盖) */
.tl-edit { right: 72px; }
.tl-edit:hover { background: #2563eb; color: #fff; }
.tl-card:hover {
	border-color: #dbeafe;
	border-left-color: #1d4ed8;
	box-shadow: 0 10px 24px rgba(37,99,235,.12);
	transform: translateX(3px);
}
.tl-title { font-weight: 600; font-size: 1.05rem; color: #0a2540; text-align: left; transition: color .2s; }
.tl-card:hover .tl-title { color: #2563eb; }
.tl-tags { display: flex; flex-wrap: wrap; gap: .35rem; margin-top: .45rem; text-align: left; }
.tl-tags span {
	background: #f1f5f9;
	font-size: .72rem;
	font-weight: 500;
	padding: .22rem .7rem;
	border-radius: 999px;
	color: #475569;
	transition: background .2s, color .2s;
}
.tl-card:hover .tl-tags span { background: #e0ecff; color: #2563eb; }
.tl-hint {
	display: inline-flex;
	align-items: center;
	gap: .25rem;
	font-size: .75rem;
	font-weight: 500;
	color: #94a3b8;
	margin-top: .55rem;
	transition: color .2s;
}
.tl-hint i { font-size: .65rem; display: inline-block; transform: rotate(-90deg); transition: transform .2s; }
.timeline-item:hover .tl-hint { color: #2563eb; }
.timeline-item:hover .tl-hint i { transform: rotate(-90deg) translateX(2px); }
.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

/* 响应式 */
@media (max-width: 768px) {
	.videolist-banner { height: 380px; }
	.bannertop-title { top: 40%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	/* 手机端标题行：标题缩小，按钮换到标题下方 */
	.brand-title { font-size: 1.3rem; }
	.brand-back { padding: .45rem .9rem; font-size: .85rem; }
	/* 手机端时间轴：更紧凑 */
	.tl-marker { width: 24px; flex: 0 0 24px; }
	.timeline::before { left: 11px; }   /* 对齐 24px marker 中心 */
	.timeline-item .tl-marker::after { width: 11px; height: 11px; top: 9px; }
	.tl-card { padding: .85rem 1rem; }
	.tl-title { font-size: .98rem; }
	/* 手机端无 hover：卡片操作按钮常显，排在"查看详情"后面(不再绝对定位悬浮) */
	.tl-toggle {
		position: static;
		opacity: 1;
		display: inline-flex;
		width: 30px;
		height: 30px;
		margin-left: .4rem;
		margin-top: .5rem;
		vertical-align: middle;
	}
	.tl-toggle svg { width: 14px; height: 14px; }
}
@media (max-width: 480px) {
	/* 手机端搜索：字段换行铺满；每个字段上下排列(第一行标题、第二行输入)，搜索按钮整行 */
	.search-wrap { flex-direction: column; align-items: stretch; gap: .6rem; }
	.search-field { width: 100%; min-width: 0; flex-direction: column; align-items: stretch; gap: .25rem; }
	.search-label { text-align: left; }
	.search-btn { width: 100%; justify-content: center; }
}
</style>

<style>
@import '../../assets/css/alibaba.css';
</style>